<template>
    <div class="investMoney acccont  Nacction">
        <div class="acctit">
            <div @click="returnpage" class="returnbtn" v-if="isApp"><i class="el-icon-arrow-left"></i></div>
            {{$t('account.transfer')}}
        </div>
        <div class="czbox">
            <div class="czboxc">
                <div class="texac sxf" >
                <span>
                    {{$t('account.transfer_fee')}}{{info.fee}}USDT<span class="bgb bgbcop" @click="copy(3)">{{$t('account.copy')}}</span>
                </span>
                <span :style="isApp ? '' : 'margin-left: 20px'">
                    {{$t('account.transfer_received_amount')}}<b class="colorr2" style="font-size: 20px;">{{info.amount}}</b>USDT
                </span>
                </div>
                <div class="texac gzimgbox">
                    {{$t('account.transfer_time_remaining')}}<span class="colorr3" style="padding: 4px">{{countDownTime}}</span>
                </div>

                <div class="gzimgbox">
                    <div class="flexbox borderr fle-sa">
                        <div :class="['item item5 bgb',type==1? 'active' :'']">
                            <div class="tip" @click="chooseType(1)">USDT-TRC20</div>
                        </div>
                        <div :class="['item item5 bgb',type==2? 'active' :'']">
                            <div class="tip" @click="chooseType(2)">USDT-ERC20</div>
                        </div>
                    </div>
                    <div v-if="type==1"  v-html="info.recharge_account" style="text-align: center"></div>
                    <div v-if="type==2"  v-html="info.recharge_account2" style="text-align: center"></div>
                    <div v-if="type==1" class="imgmimi">
                        <span class="colory wordbreak">{{info.trc20}}</span> <span class="bgb bgbcop" @click="copy(1)">{{$t('account.copy')}}</span>
                    </div>
                    <div v-if="type==2" class="imgmimi">
                        <span class="colory wordbreak">{{info.erc20}}</span> <span class="bgb bgbcop" @click="copy(2)">{{$t('account.copy')}}</span>
                    </div>
                </div>
                <div class="acctentB">
                    <div class="formbox">
                        <div class="tiplin2 colorr2">
                            {{$t('account.trader_tips')}}
                        </div>
                        <div class="tiplin2 colorr2">1.{{$t('account.transfer_auto_clear')}}</div>
                        <div class="tiplin2">2.{{$t('account.transfer_service_charge_tip1')}}{{info.amount}}USDT{{$t('account.transfer_service_charge_tip2')}}(<span class="colory">{{info.address}}</span>){{$t('account.transfer_service_charge_tip3')}}</div>
                        <div class="tiplin2">3.{{$t('account.transfer_service_charge_tip4')}}</div>
                        <div class="tiplin2">4.{{$t('account.transfer_service_charge_tip5')}}</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import {get_vip_transfer} from '@/api/transfer'

    export default {
        name: 'vipTransfer',
        data() {
            return {
                sn: '',
                toUser: '',
                type: 1,
                countDownTime: '00:00',
                countDownFn: null,
                leftTransferTime: '',
                classOption: {
                    step: 0.5
                },
                info: {
                    sn: '',
                    amount: '',
                    fee: '',
                    fee_rate: '',
                    address_type: '',
                    address: '',
                    expiretime: '',
                    uploadtime: '',
                    lefttime: '',
                    leftsecond: 0,
                    recharge_account: '',
                    recharge_account2: '',
                    trc20: '',
                    erc20: '',
                },

            }
        },
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }
        },
        mounted() {
            this.sn = this.$route.query.sn
            this.toUser = this.$route.query.toUser
            this.getData()
        },
        methods: {
            returnpage() {
                this.$router.go(-1)
            },
            chooseType(type) {
                this.type = type;
            },
            isApp2() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            copy(type){
                let address = "";
                if(type == 1){  // TRC20
                    address = this.info.trc20
                }else if(type == 2){    // ERC20
                    address = this.info.erc20
                }else if(type == 3){    // 手续费
                    address = this.info.fee
                }
                // 创建输入框元素
                let oInput = document.createElement('input');
                // 将想要复制的值
                oInput.value = address;
                // 页面底部追加输入框
                document.body.appendChild(oInput);
                // 选中输入框
                oInput.select();
                // 执行浏览器复制命令
                document.execCommand('Copy');
                // 弹出复制成功信息
                this.$message.success(this.$t('account.copy_success'));
                // 复制后移除输入框
                oInput.remove()
            },
            getData() {
                get_vip_transfer({sn: this.sn, toUser: this.toUser}).then(res => {
                    console.log(res)
                    if(res.code == 1){
                        this.info = res.data
                        let recharge_account = this.info.recharge_account;

                        recharge_account = recharge_account.replace(/height="\d+"/gi, '');
                        recharge_account = recharge_account.replace(/width="\d+"/gi, '');
                        recharge_account = recharge_account.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, '');
                        recharge_account = recharge_account.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, reSrc) {
                            //reSrc,返回每个匹配的字符串
                            let newImg = '<a href="' + reSrc + '" target="_blank"><img src="' + reSrc + '" alt="" style="width:80%;" /></a>';
                            return newImg;
                        });
                        this.info.recharge_account = recharge_account;


                        let recharge_account2 = this.info.recharge_account2;

                        recharge_account2 = recharge_account2.replace(/height="\d+"/gi, '');
                        recharge_account2 = recharge_account2.replace(/width="\d+"/gi, '');
                        recharge_account2 = recharge_account2.replace(/style\s*?=\s*?([‘"])[\s\S]*?\1/ig, '');
                        recharge_account2 = recharge_account2.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, reSrc) {
                            //reSrc,返回每个匹配的字符串
                            let newImg = '<a href="' + reSrc + '" target="_blank"><img src="' + reSrc + '" alt="" style="width:80%;" /></a>';
                            return newImg;
                        });
                        this.info.recharge_account2 = recharge_account2;
                        this.leftTransferTime = res.data.lefttime
                        if(this.leftTransferTime && !res.uploadtime){
                            this.countDown()
                        }
                    }else{
                        this.$message.error(res.msg)
                    }


                }).catch(_ => {

                })
            },
            countDownFun() {
                let result = this.info.leftsecond;
                result--;
                this.info.leftsecond = result;
                let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
                let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
                let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
                let s = parseInt(result % 60);
                //当倒计时结束时，改变内容
                if (result <= 0) {
                    return 0
                }
                if (h < 10) {
                    h = "0" + h
                }
                if (m < 10) {
                    m = "0" + m
                }
                if (s < 10) {
                    s = "0" + s
                }
                if (h == 0 && m == 0) {
                    return s + "s"
                } else if (h == 0) {
                    return m + ":" + s
                } else if (d == 0) {
                    return h + ":" + m + ":" + s
                } else {
                    if(d > 1){
                        return d + this.$t('account.days') + h + ":" + m + ":" + s
                    }else{
                        return d + this.$t('account.day') + h + ":" + m + ":" + s
                    }
                }
            },
            // 定时器
            countDown() {
                let that = this;
                that.countDownFn = setInterval(() => {
                    let html = that.countDownFun()
                    if (html === 0) {
                        that.leftTransferTime = ''
                        clearInterval(that.countDownFn); //清除定时器
                        if (that.isApp2()) {
                            that.$router.replace('/home/accountApp')
                        } else {
                            that.$router.replace('/home/account')
                        }
                    } else {
                        that.countDownTime = html;
                    }
                }, 1000)
            },
            submitForm() {
                this.submit()
            },
        }
    }
</script>
<style lang="scss" scoped>
    .disabled {
        ::v-deep .el-upload--picture-card {
            display: none;
        }
    }
    .imgmimi{
        text-align: center;
      img{
        width: 20px;
      }
    }

    .investMoney {
        font-size: 18px;
        width: 800px;
        .accctit {
            font-size: 20px;
            font-weight: bold;
            line-height: 50px;
        }

        .tiplin {
            line-height: 40px;
        }

        .marr {
            text-align: center;
            line-height: 26px;

            img {
                width: 200px;
                height: 200px;
                margin-right: 30px;
            }
        }
        .czbox{
            padding-top: 20px;
        }
        .gzimgbox {
            width: 60%;
            margin: 20px auto;
        }

        .examplelistbox {
            img {
                width: 300px;
                height: auto;
                margin: 10px;
            }
        }
        .wordbreak{
          word-wrap: break-word;
          word-break: normal;
            font-size: 12px;
        }

        .sylistbox {
            .tablet {
                width: 100%;
                background: #3a3a3a;

                & > div {
                    width: 33.2%;
                    height: 50px;
                    border: 1px solid #5c5c5c;
                    line-height: 50px;
                    font-size: 18px;

                }

                &.itemvue {
                    border: 0px;
                    color: #fff;
                    background: #3a3a3a;

                    & > div {
                        border: 0px;
                        color: #fff;
                    }

                }
            }

            .srollbox {
                height: 400px;

                overflow: hidden;
            }
        }

        .examplebox {
            padding: 30px 0px;
        }
        .acctentB{
            text-align: left;
        }
        .formbox {
            width: 80%;
            margin: 30px auto;
            /*padding: 30px;
            border-radius: 20px;
            border: 1px solid rgb(85, 85, 85);*/
            box-sizing: border-box;
            .bgb {
                margin: 40px 0px 20px 0px;
                padding: 14px 30px;
                background: #1750cc;
                color: #fff;
                font-size: 20px;
            }
        }
    }

    .item5{
      width: 50%;
      &.bgb {
        &:nth-child(1){
          border-bottom-left-radius: 4px;
          border-top-left-radius: 4px;
        }
        &:nth-child(2){
          border-bottom-right-radius: 4px;
          border-top-right-radius: 4px;
        }
                margin: 10px 0px 10px 0px;
                padding: 8px 20px;
                background: #fff;
                color: #1750cc;
                font-size: 14px;
                border: 1px solid #fff;
                cursor: pointer;
                border-radius: 0px;
                text-align: center;
                &.active{
                  border: 1px solid #e0c447;
                  background: #1750cc;
                  color: #fff;
                  font-size: 16px;
                  font-weight: bold;
                }
            }

    }
    .bgb {
                margin: 60px auto;
                padding: 10px 10px;
                background: #1750cc;
                color: #fff;
                font-size: 16px;
                border-radius: 4px;
                cursor: pointer;
                width: 80%;
            }
    .bgbcop{
        margin-left: 10px;
        line-height: 1;
        padding: 4px 10px !important;
    }
     .sxf{
        margin-top: 40px;
    }
    @media (max-width: 730px) {
        .Nacction{
            .czbox{
                padding: 10px;
                .czboxc{
                    background: #333;
                    padding: 10px;
                    border-radius: 20px;
                }
                .gzimgbox{
                    margin: 1px auto;
                }
                .bgb{
                    margin: 6px auto;
                }
            }
            .sxf{
                margin-top: -3px;
                span{
                    display: block;
                    .bgbcop{
                        display: inline-block;
                        width: 32px;
                        padding: 5px 10px;
                        line-height: 1;
                        margin-left: 10px;

                    }
                }
            }
            .texac{
                text-align: center !important;
            }
        }

    }

</style>
